import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {SimpleReelModelEventData} from "../../core/reel/IReelData";
import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {FITH2ReelView} from "./FITH2ReelView";
import {ISymbolData} from "../symbols/FITH2Symbol";

export class FITH2AvalancheReelModel{
    private _reelId: number;
    private _reelView: FITH2ReelView;
    public readonly events: APIEventSystem | undefined;

    constructor(id: number, triggerEvents: boolean = true) {
        this._reelId = id;
        this._reelView = new FITH2ReelView(id);
        if (triggerEvents) {
            this.events = SlotGame.apiPlugin.eventSystemFactory.create();
            this.events.on("ReelStateChange", (data: SimpleReelModelEventData) => this.onReelStateChange(data)); //To prevent event system from saving once callbacks if no on callbacks is set.
        }
    }

    public init(symbols: ISymbolData[]): void {
        this._reelView.initReel(symbols);
    }

    private onReelStateChange(data: SimpleReelModelEventData): void {
        this.events?.trigger(data.state, data);
    }

    public get reelView():FITH2ReelView{
        return this._reelView;
    }
}